import { FormattedMessage } from "react-intl";
import renderDateTime from "utils/renderDateTime";
import { EventOccurrenceWithRelations } from "@ticketingplatform/api/dist/event/fragments/__generated__/eventOccurrenceWithRelations";
import { TicketStatus } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { SCREENS } from "navigation/consts";
import { Link } from "@react-navigation/native";

import * as Styled from "./styles";
import { useEventTicketAggregationProgress } from "./hooks";

const EventListItem: React.FC<EventOccurrenceWithRelations> = ({
  id: eventOccurrenceId,
  date,
  event,
  ticketsAggregation,
}) => {
  // `event` is behind an @include directive (eventInclude always requested).
  const { name, timezone, venue } = event!;
  const { total, quantities, percentages } =
    useEventTicketAggregationProgress(ticketsAggregation);

  return (
    <Link
      key={eventOccurrenceId}
      to={{
        screen: SCREENS.Main,
        params: { eventOccurrenceId },
      }}
    >
      <Styled.Wrapper>
        <Styled.Name>{name}</Styled.Name>
        <Styled.Description>
          <Styled.DescriptionLabel>
            <FormattedMessage defaultMessage="Location" />
          </Styled.DescriptionLabel>
          {venue?.name}
        </Styled.Description>
        <Styled.Description>
          <Styled.DescriptionLabel>
            <FormattedMessage defaultMessage="Date and time" />
          </Styled.DescriptionLabel>
          {renderDateTime(date, timezone)}
        </Styled.Description>
        <Styled.ProgressLabel>
          <Styled.ProgressBar value={percentages[TicketStatus.SCANNED]} />
          {quantities[TicketStatus.SCANNED]}/{total}
        </Styled.ProgressLabel>
      </Styled.Wrapper>
    </Link>
  );
};

export default EventListItem;
